import { Link } from '@/components/atoms/Link';
import { EVMonoIcon } from '@/components/icons';
import clsx from 'clsx';
import { FC } from 'react';

export interface PoweredByFooterProps {
  bgFill?: boolean;
  className?: string;
}

export const PoweredByFooter: FC<PoweredByFooterProps> = ({
  bgFill = false,
  className = '',
}) => {
  return (
    <div
      className={clsx(
        'flex items-center justify-center pb-[14px] pt-[15px]',
        {
          'bg-neutral-100': bgFill,
        },
        className
      )}
    >
      <Link href="https://ev.com" target="_blank">
        <div className="flex items-center gap-xs">
          <div className="text-microNormal text-neutral-600">Powered by</div>
          <EVMonoIcon />
        </div>
      </Link>
    </div>
  );
};
